export default [
  {
    category: 'SuperStar',
    name: 'Takuya Noguchi',
    gitlab: 'https://gitlab.com/tnir',
    merged_mrs: 155,
  },
  {
    category: 'SuperStar',
    name: 'George Tsiolis',
    gitlab: 'https://gitlab.com/gtsiolis',
    merged_mrs: 117,
  },
  {
    category: 'Star',
    name: 'Ben Bodenmiller',
    gitlab: 'https://gitlab.com/bbodenmiller',
    merged_mrs: 64,
  },
  {
    category: 'Star',
    name: 'gfyoung',
    gitlab: 'https://gitlab.com/gfyoung',
    merged_mrs: 45,
  },
  {
    category: 'Star',
    name: 'Lee Tickett',
    gitlab: 'https://gitlab.com/leetickett',
    merged_mrs: 44,
  },
  {
    category: 'Star',
    name: 'Utkarsh Gupta',
    gitlab: 'https://gitlab.com/utkarsh2102',
    merged_mrs: 39,
  },
  {
    category: 'Star',
    name: 'Arun Kumar Mohan',
    gitlab: 'https://gitlab.com/auua',
    merged_mrs: 28,
  },
  {
    category: 'Star',
    name: 'Jacopo Beschi',
    gitlab: 'https://gitlab.com/jacopo-beschi',
    merged_mrs: 25,
  },
  {
    category: 'Star',
    name: 'Robert Schilling',
    gitlab: 'https://gitlab.com/razer6',
    merged_mrs: 25,
  },
  {
    category: 'Star',
    name: 'Antony Liu',
    gitlab: 'https://gitlab.com/antonyliu',
    merged_mrs: 24,
  },
  {
    category: 'Star',
    name: 'Harrison Healey',
    gitlab: 'https://gitlab.com/hmhealey',
    merged_mrs: 24,
  },
  {
    category: 'Star',
    name: 'Michel Engelen',
    gitlab: 'https://gitlab.com/michel.engelen',
    merged_mrs: 22,
  },
  {
    category: 'Star',
    name: 'Marvin Karegyeya',
    gitlab: 'https://gitlab.com/nuwe1',
    merged_mrs: 20,
  },
  {
    category: 'Star',
    name: 'Jasper Maes',
    gitlab: 'https://gitlab.com/jlemaes',
    merged_mrs: 18,
  },
  {
    category: 'Star',
    name: 'Brian Kabiro',
    gitlab: 'https://gitlab.com/briankabiro',
    merged_mrs: 17,
  },
  {
    category: 'Star',
    name: 'Katrin Leinweber',
    gitlab: 'https://gitlab.com/katrinleinweber',
    merged_mrs: 17,
  },
  {
    category: 'Star',
    name: 'Lucy Fox',
    gitlab: 'https://gitlab.com/lucyfox',
    merged_mrs: 17,
  },
  {
    category: 'Star',
    name: 'Yoginth',
    gitlab: 'https://gitlab.com/yo',
    merged_mrs: 17,
  },
  {
    category: 'Star',
    name: 'Roger Meier',
    gitlab: 'https://gitlab.com/bufferoverflow',
    merged_mrs: 16,
  },
  {
    category: 'Star',
    name: 'Diego Louzán',
    gitlab: 'https://gitlab.com/dlouzan',
    merged_mrs: 15,
  },
  {
    category: 'Star',
    name: 'Tony Kwok',
    gitlab: 'https://gitlab.com/tony.k',
    merged_mrs: 15,
  },
  {
    category: 'Star',
    name: 'Hiroyuki Sato',
    gitlab: 'https://gitlab.com/hiroponz',
    merged_mrs: 14,
  },
  {
    category: 'Star',
    name: 'Mathieu Parent',
    gitlab: 'https://gitlab.com/sathieu',
    merged_mrs: 14,
  },
  {
    category: 'Star',
    name: 'Elan Ruusamäe',
    gitlab: 'https://gitlab.com/glensc',
    merged_mrs: 13,
  },
  {
    category: 'Star',
    name: 'Alexander Oleynikov',
    gitlab: 'https://gitlab.com/0leynikov',
    merged_mrs: 12,
  },
  {
    category: 'Star',
    name: 'Dinesh Panda',
    gitlab: 'https://gitlab.com/dineshpanda92',
    merged_mrs: 12,
  },
  {
    category: 'Star',
    name: 'Jesse Hall',
    gitlab: 'https://gitlab.com/jessehall3',
    merged_mrs: 12,
  },
  {
    category: 'Star',
    name: 'Chris Baumbauer',
    gitlab: 'https://gitlab.com/cab105',
    merged_mrs: 11,
  },
  {
    category: 'Star',
    name: 'Cédric Tabin',
    gitlab: 'https://gitlab.com/ctabin',
    merged_mrs: 11,
  },
  {
    category: 'Star',
    name: 'Marc Schwede',
    gitlab: 'https://gitlab.com/schwedenmut',
    merged_mrs: 11,
  },
  {
    category: 'Star',
    name: 'Minghuan Lei',
    gitlab: 'https://gitlab.com/leiminghany',
    merged_mrs: 11,
  },
  {
    category: 'Star',
    name: 'Stefan Schmalzhaf',
    gitlab: 'https://gitlab.com/the_s',
    merged_mrs: 11,
  },
  {
    category: 'Enthusiast',
    name: 'Shan',
    gitlab: 'https://gitlab.com/sgohar',
    merged_mrs: 10,
  },
  {
    category: 'Enthusiast',
    name: 'Jan Beckmann',
    gitlab: 'https://gitlab.com/kingjan1999',
    merged_mrs: 9,
  },
  {
    category: 'Enthusiast',
    name: 'Max Wittig',
    gitlab: 'https://gitlab.com/max-wittig',
    merged_mrs: 9,
  },
  {
    category: 'Enthusiast',
    name: 'Bogdan',
    gitlab: 'https://gitlab.com/bogdanvlviv',
    merged_mrs: 8,
  },
  {
    category: 'Enthusiast',
    name: 'Guillaume Grossetie',
    gitlab: 'https://gitlab.com/g.grossetie',
    merged_mrs: 8,
  },
  {
    category: 'Enthusiast',
    name: 'Matthias van de Meent',
    gitlab: 'https://gitlab.com/matthias.vandemeent',
    merged_mrs: 8,
  },
  {
    category: 'Enthusiast',
    name: 'Peter Marko',
    gitlab: 'https://gitlab.com/petermarko',
    merged_mrs: 8,
  },
  {
    category: 'Enthusiast',
    name: 'Victor Wu',
    gitlab: 'https://gitlab.com/victorwuky',
    merged_mrs: 8,
  },
  {
    category: 'Enthusiast',
    name: 'Aaron Walker',
    gitlab: 'https://gitlab.com/walkafwalka',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'Alexander Kutelev',
    gitlab: 'https://gitlab.com/kutelev',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'Hannes Rosenögger',
    gitlab: 'https://gitlab.com/haynes',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'Maneschi Romain',
    gitlab: 'https://gitlab.com/RmManeschi',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'Martin Hobert',
    gitlab: 'https://gitlab.com/epenance',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'Mike Rennie',
    gitlab: 'https://gitlab.com/mrennie',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'Riccardo Padovani',
    gitlab: 'https://gitlab.com/rpadovani',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'Robert Orefice',
    gitlab: 'https://gitlab.com/rsogitlab',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'Fabio Huser',
    gitlab: 'https://gitlab.com/fh1ch',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'Spell Bot',
    gitlab: 'https://gitlab.com/Spellbot.not',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'ftab',
    gitlab: 'https://gitlab.com/ftab',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'Allen Lai',
    gitlab: 'https://gitlab.com/allenlai18',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Amanda Schaefer',
    gitlab: 'https://gitlab.com/aschaefer',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Amit Rathi',
    gitlab: 'https://gitlab.com/amit1rrr',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Chris Boot',
    gitlab: 'https://gitlab.com/bootc',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Fabian Schneider',
    gitlab: 'https://gitlab.com/fabsrc',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Gokhan Apaydin',
    gitlab: 'https://gitlab.com/gokhanap',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Mateusz Nowotynski',
    gitlab: 'https://gitlab.com/maxmati',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Michael Friedrich',
    gitlab: 'https://gitlab.com/dnsmichi',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Paulo Ribeiro',
    gitlab: 'https://gitlab.com/prcr',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Peter Dave Hello',
    gitlab: 'https://gitlab.com/PeterDaveHello',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Philipp C. H.',
    gitlab: 'https://gitlab.com/phich',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Praveen Arimbrathodiyil',
    gitlab: 'https://gitlab.com/pravi',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Rajendra kadam',
    gitlab: 'https://gitlab.com/raju249',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Semyon Pupkov',
    gitlab: 'https://gitlab.com/artofhuman',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Thad Guidry',
    gitlab: 'https://gitlab.com/thadguidry',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Vic Iglesias',
    gitlab: 'https://gitlab.com/viglesiasce',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Willi Eggeling',
    gitlab: 'https://gitlab.com/thewilli',
    merged_mrs: 5,
  },
];
